import styled from 'styled-components';

export const StyledError = styled.div`
  background: #ededed;
  height: 100vh;
`;
